import { FabricObject } from "fabric";
import antiScale from "./antiScale";
import { nextShape, createCircle, createHexagon, createHeart, createRoundedRect } from "./shapes"

export function addCircleClip(obj: FabricObject) {
  obj.noScaleCache = false;
  const minSize = Math.min(obj.height, obj.width);
  function scale() {
    if (!obj.clipPath) return
    const [scaleX, scaleY] = antiScale(obj);
    obj.clipPath.set({ scaleY, scaleX });
    obj.clipPath.dirty = true;
  };
  obj.clipPath = createCircle({ radius: minSize / 2 });
  scale();
  obj.on("scaling", scale);
}

export function addHeartClip(obj: FabricObject) {
  function scale() {
    const minSize = Math.min(obj.height, obj.width) / 2;
    const scaleFactor = minSize / 14; // La hauteur totale du cœur est d'environ 28 unités (de -14 à 14)
    const heart = createHeart({ scaleX: scaleFactor, scaleY: scaleFactor })
    obj.clipPath = heart;
  }
  scale();
  obj.on("scaling", scale);
}

export function addHexagonClip(obj: FabricObject) {
  const scale = () => {
    const minSize = Math.min(obj.height, obj.width) / 2;
    const scaleFactor = minSize / 24; // hauteur d'enviroin 50
    const hexa = createHexagon({ scaleX: scaleFactor, scaleY: scaleFactor })
    obj.clipPath = hexa;
  };
  scale();
  obj.on("scaling", scale);
}

export function addRoundedClip(obj: FabricObject) {
  obj.noScaleCache = false;
  const scale = () => {
    if (!obj.clipPath) return
    // Contrecarrer le scale irrégulier en applicant antiscale sur les angles 
    const [scaleX, scaleY] = antiScale(obj);
    const minSize = Math.min(obj.height, obj.width);
    obj.clipPath.set({
      height: obj.height,
      width: obj.width,
      ry: minSize * 0.15 * scaleY,
      rx: minSize * 0.15 * scaleX
    });
  };
  obj.clipPath = createRoundedRect({});
  scale();
  obj.on("scaling", scale);
}

export const switchClip = (obj: FabricObject) => {
  obj.off("scaling");
  const clipPath = obj?.clipPath;
  const shape = nextShape(clipPath?.id)
  switch (shape) {
    case "rect": return obj.clipPath = null
    case "rounded": return addRoundedClip(obj);
    case "circle": return addCircleClip(obj);
    case "heart": return addHeartClip(obj);
    case "hexagon": return addHexagonClip(obj);
  }
};
